/**
 * Design System - Responsive Utilities
 *
 * Utilities for responsive design
 */

import { breakpointValues } from '../tokens/breakpoints';

/**
 * Check if current window width matches a breakpoint
 */
export const useBreakpoint = (
  breakpoint: keyof typeof breakpointValues
): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth >= breakpointValues[breakpoint];
};

/**
 * Get current breakpoint name
 */
export const getCurrentBreakpoint = (): keyof typeof breakpointValues => {
  if (typeof window === 'undefined') return 'xs';

  const width = window.innerWidth;

  if (width >= breakpointValues['2xl']) return '2xl';
  if (width >= breakpointValues.xl) return 'xl';
  if (width >= breakpointValues.lg) return 'lg';
  if (width >= breakpointValues.md) return 'md';
  if (width >= breakpointValues.sm) return 'sm';
  return 'xs';
};

/**
 * Check if device is mobile
 */
export const isMobile = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < breakpointValues.md;
};

/**
 * Check if device is tablet
 */
export const isTablet = (): boolean => {
  if (typeof window === 'undefined') return false;
  return (
    window.innerWidth >= breakpointValues.md &&
    window.innerWidth < breakpointValues.lg
  );
};

/**
 * Check if device is desktop
 */
export const isDesktop = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth >= breakpointValues.lg;
};
